/* Ohrwunder Theme JS – ohne Abhängigkeiten */
(function () {
  'use strict';
  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
  var money = function (cents) { return euro.format((parseInt(cents, 10) || 0) / 100); };
  var mmss = function (s) { if (!isFinite(s)) return '–:––'; var m = Math.floor(s / 60), r = Math.floor(s % 60); return m + ':' + (r < 10 ? '0' : '') + r; };
  var PLAY = '<path d="M7 4.5v15l13-7.5z"/>', PAUSE = '<path d="M6.5 4.5h4v15h-4zM13.5 4.5h4v15h-4z"/>';

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    // Mobile Menü (Drawer, modaler <dialog>: Fokus bleibt im Menü, Esc schließt)
    var drawer = document.querySelector('[data-drawer]'), opener = document.querySelector('[data-menu-open]');
    if (drawer && opener && typeof drawer.showModal === 'function') {
      var root = document.documentElement, closeTimer = null;
      var reduced = function () { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; };
      var openDrawer = function () {
        if (drawer.open) return;
        clearTimeout(closeTimer);
        root.style.setProperty('--sbw', (window.innerWidth - root.clientWidth) + 'px');
        root.classList.add('drawer-lock');
        drawer.showModal();
        drawer.getBoundingClientRect();
        drawer.classList.add('is-open');
        opener.setAttribute('aria-expanded', 'true');
      };
      var closeDrawer = function (instant) {
        if (!drawer.open) return;
        drawer.classList.remove('is-open');
        opener.setAttribute('aria-expanded', 'false');
        var done = function () { drawer.close(); root.classList.remove('drawer-lock'); opener.focus({ preventScroll: true }); };
        clearTimeout(closeTimer);
        if (instant === true) done(); else closeTimer = setTimeout(done, reduced() ? 140 : 220);
      };
      opener.addEventListener('click', openDrawer);
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', function () { closeDrawer(); }); });
      drawer.querySelectorAll('a[href]').forEach(function (a) { a.addEventListener('click', function () { closeDrawer(true); }); });
      drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeDrawer(); });
      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
        if (e.key !== 'Tab') return;
        var f = drawer.querySelectorAll('.drawer-panel a[href], .drawer-panel button'), first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      var wide = window.matchMedia('(min-width: 961px)');
      var onWide = function (m) { if (m.matches) closeDrawer(true); };
      if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
    }

    // Audio: ein Player gleichzeitig
    var audio = new Audio(); audio.preload = 'none'; var current = null;
    function reset(p) { var s = p.querySelector('.play svg'); if (s) s.innerHTML = PLAY; var b = p.querySelector('.bar i'); if (b) b.style.width = '0'; var c = p.querySelector('[data-cur]'); if (c) c.textContent = '0:00'; }
    document.querySelectorAll('[data-player]').forEach(function (p) {
      var btn = p.querySelector('.play[data-src]'); if (!btn) return;
      var src = btn.getAttribute('data-src');
      btn.addEventListener('click', function () {
        if (current === p && !audio.paused) { audio.pause(); return; }
        if (current !== p) { if (current) reset(current); audio.src = src; current = p; }
        audio.play();
      });
    });
    audio.addEventListener('loadedmetadata', function () { if (current) { var d = current.querySelector('[data-dur]'); if (d) d.textContent = mmss(audio.duration); } });
    audio.addEventListener('play', function () { if (current) current.querySelector('.play svg').innerHTML = PAUSE; });
    audio.addEventListener('pause', function () { if (current) current.querySelector('.play svg').innerHTML = PLAY; });
    audio.addEventListener('timeupdate', function () {
      if (!current) return;
      current.querySelector('.bar i').style.width = (audio.currentTime / audio.duration * 100 || 0) + '%';
      current.querySelector('[data-cur]').textContent = mmss(audio.currentTime);
    });

    // Einblenden beim Scrollen: robust bei Anker-Sprüngen und schnellem Scrollen
    initReveal();

    // Galerie-Thumbnails
    var main = document.getElementById('mainImg');
    window.owSwapMain = swapMain;
    function swapMain(src, srcset, alt) {
      if (!main || !src) return;
      if (srcset) main.setAttribute('srcset', srcset); else main.removeAttribute('srcset');
      if (main.getAttribute('src') !== src) main.src = src;
      if (alt != null) main.alt = alt;
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('active', (x.getAttribute('data-full') || '').split('?')[0] === src.split('?')[0]); });
    }
    document.querySelectorAll('[data-thumb]').forEach(function (t) {
      var pick = function () { document.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('active'); }); t.classList.add('active'); if (main) { swapMain(t.getAttribute('data-full') || t.src, t.getAttribute('data-srcset'), t.alt); } };
      t.addEventListener('click', pick);
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });

    // Song-Konfigurator
    document.querySelectorAll('form.ow-config').forEach(initConfig);
    initCart();
  });

  // Warenkorb: personalisierte Positionen immer Menge 1, Extras nur mit ihrem Song
  function initCart() {
    if (!window.fetch) return;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var post = function (updates) {
      return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { if (!r.ok) throw r; return r.json(); });
    };
    var fix = document.querySelector('[data-cart-fix]');
    if (fix) {
      var n = parseInt(sessionStorage.getItem('owCartFix') || '0', 10);
      if (n < 2) {
        sessionStorage.setItem('owCartFix', String(n + 1));
        var up = {};
        fix.getAttribute('data-cart-fix').split(',').forEach(function (kv) { var i = kv.lastIndexOf(':'); if (i > 0) up[kv.slice(0, i)] = parseInt(kv.slice(i + 1), 10); });
        post(up).then(function () { location.reload(); }).catch(function () {});
      }
    } else { try { sessionStorage.removeItem('owCartFix'); } catch (x) {} }
    document.querySelectorAll('a[data-remove-also]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var up = {}; up[a.getAttribute('data-remove')] = 0;
        a.getAttribute('data-remove-also').split(',').forEach(function (k) { if (k) up[k] = 0; });
        a.setAttribute('aria-busy', 'true');
        post(up).then(function () { location.reload(); }).catch(function () { location.href = a.href; });
      });
    });
  }

  function initReveal() {
    window.owRevealInit = true;
    var root = document.documentElement;
    var els = Array.prototype.slice.call(document.querySelectorAll('.reveal'));
    if (!root.classList.contains('ow-reveal') || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); root.classList.remove('ow-reveal'); return; }
    var pending = els.slice();
    function show(el) { el.classList.add('in'); if (io) io.unobserve(el); }
    // Alles, was im Viewport, darüber oder knapp darunter liegt, sofort zeigen
    function sweep() {
      var limit = window.innerHeight * 1.25;
      pending = pending.filter(function (el) { if (el.getBoundingClientRect().top < limit) { show(el); return false; } return true; });
      if (!pending.length) detach();
    }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { show(e.target); var i = pending.indexOf(e.target); if (i > -1) pending.splice(i, 1); } }); }, { rootMargin: '0px 0px 25% 0px', threshold: 0 });
    var ticking = false;
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; sweep(); }); }
    function onHash() { requestAnimationFrame(sweep); }
    function detach() { window.removeEventListener('scroll', onScroll); window.removeEventListener('hashchange', onHash); window.removeEventListener('resize', onScroll); }
    sweep();
    pending.forEach(function (el) { io.observe(el); });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('hashchange', onHash);
    window.addEventListener('load', sweep);
    window.addEventListener('pageshow', sweep);
    document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a[href*="#"]'); if (a) setTimeout(sweep, 0); });
  }

  function initConfig(form) {
    var q = new URLSearchParams(location.search);
    ['anlass', 'fuer'].forEach(function (k) {
      var val = q.get(k); if (!val) return;
      var name = k === 'anlass' ? 'properties[Anlass]' : 'properties[Beschenkt wird]';
      form.querySelectorAll('input[name="' + name + '"]').forEach(function (i) { if (i.value.toLowerCase().indexOf(val.toLowerCase()) === 0) i.checked = true; });
    });
    var story = form.querySelector('[data-story]'), count = form.querySelector('[data-count]');
    var name = form.querySelector('[data-name]'), waiver = form.querySelector('[data-waiver]');
    var extra = form.querySelector('[data-extra]'), extraWrap = form.querySelector('[data-extra-style]'), extraSel = form.querySelector('[data-extra-style-select]');
    var err = form.querySelector('[data-error]'), atc = form.querySelector('[data-atc]'), hint = form.querySelector('[data-hint]');
    var main = document.getElementById('mainImg');
    var video = initPhotos(form, name);
    var date = initDate(form);

    function selected() { return form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"]'); }
    function update() {
      var v = selected(); if (!v) return;
      var physical = v.getAttribute('data-shipping') === 'true';
      form.querySelectorAll('[data-physical]').forEach(function (el) {
        el.hidden = !physical;
        el.querySelectorAll('input, select, textarea').forEach(function (i) { i.disabled = !physical; });
      });
      var total = parseInt(v.getAttribute('data-price'), 10) || 0, extras = '';
      if (extra && extra.checked) { total += parseInt(extra.getAttribute('data-price'), 10) || 0; extras = extra.getAttribute('data-title') + ' +\u00a0' + money(extra.getAttribute('data-price')); }
      if (extraWrap) extraWrap.hidden = !(extra && extra.checked);
      var s = function (sel, txt) { var el = form.querySelector(sel); if (el) el.textContent = txt; };
      s('[data-sum-pkg]', v.getAttribute('data-title') || '');
      s('[data-sum-pkg-price]', money(v.getAttribute('data-price')));
      s('[data-sum-extras]', extras);
      s('[data-total]', money(total));
      video.toggle(v.getAttribute('data-video') === 'true', physical);
      var img = v.getAttribute('data-image');
      if (img && main && window.owSwapMain) window.owSwapMain(img, v.getAttribute('data-image-srcset'), v.getAttribute('data-image-alt'));
      var ok = name && name.value.trim() && story && story.value.trim() && waiver && waiver.checked && video.rightsOk();
      if (hint) hint.style.visibility = ok ? 'hidden' : 'visible';
    }
    form.addEventListener('input', update); form.addEventListener('change', update);
    if (story && count) story.addEventListener('input', function () { count.textContent = story.value.length; });

    form.addEventListener('submit', function (e) {
      if (err) { err.hidden = true; err.textContent = ''; }
      if (date && !date.check(true, true)) { e.preventDefault(); return; }
      if (waiver && !waiver.checked && name && name.value.trim() && story && story.value.trim()) {
        e.preventDefault();
        if (err) { err.hidden = false; err.textContent = 'Bitte bestätige noch den Hinweis zur sofortigen Ausführung. Ohne deine Zustimmung können wir mit deinem Song nicht beginnen.'; }
        waiver.focus(); return;
      }
      if (video.missingCover()) {
        e.preventDefault();
        if (err) { err.hidden = false; err.textContent = 'Fürs Acrylglas-Cover brauchen wir mindestens ein Foto. Bitte wähle bei „Deine Fotos“ mindestens ein Foto aus.'; }
        video.focus(); return;
      }
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
      if (!window.fetch || !window.FormData) return; // ohne JS-Funktionen normaler Formularversand
      e.preventDefault();
      if (atc) { atc.disabled = true; atc.textContent = 'Wird vorbereitet …'; }
      var addUrl = (form.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
      var cartUrl = form.getAttribute('data-cart-url') || '/cart';
      // Eindeutige ID je Song: verhindert, dass zwei Songs zu einer Position mit Menge 2 verschmelzen, und bindet Extras an genau diesen Song
      var songId = 'S' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase();
      video.ready().then(function () {
        var fd = new FormData(form);
        fd.set('quantity', '1');
        fd.append('properties[_Song-ID]', songId);
        if (waiver && waiver.checked) fd.append('properties[_Zustimmung Zeitpunkt]', new Date().toISOString());
        var n = video.append(fd);
        if (atc) atc.textContent = n ? (n === 1 ? 'Foto wird hochgeladen …' : n + ' Fotos werden hochgeladen …') : 'Wird hinzugefügt …';
        return fetch(addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          var xv = form.getAttribute('data-extra-variant');
          if (extra && extra.checked && xv) {
            var props = { 'Für Song': (name ? name.value.trim() : ''), 'Zweiter Stil': extraSel ? extraSel.value : '', '_Gehört zu': songId };
            return fetch(addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(xv, 10), quantity: 1, properties: props }] }) });
          }
        })
        .then(function () { window.location.href = cartUrl; })
        .catch(function (j) {
          if (atc) { atc.disabled = false; atc.textContent = 'In den Warenkorb'; }
          if (err) { err.hidden = false; err.textContent = (j && (j.description || j.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.'; }
        });
    });
    update();
  }

  // Wunschtermin: Texteingabe TT.MM.JJJJ (überall gleich, auch ohne deutsches Browser-Gebietsschema) plus nativer Kalender
  function initDate(form) {
    var wrap = form.querySelector('[data-date]'); if (!wrap) return null;
    var txt = wrap.querySelector('[data-date-text]'), nat = wrap.querySelector('[data-date-native]'), msg = form.querySelector('[data-date-error]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var iso = function (d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); };
    var de = function (d) { return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); };
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var min = new Date(today); min.setDate(min.getDate() + 1);
    var max = new Date(today); max.setFullYear(max.getFullYear() + 1);
    if (nat) { nat.min = iso(min); nat.max = iso(max); }
    function parse(v) {
      var m = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(v.trim()); if (!m) return null;
      var d = new Date(+m[3], +m[2] - 1, +m[1]);
      return d.getDate() === +m[1] && d.getMonth() === +m[2] - 1 ? d : null;
    }
    function check(show, focus) {
      var v = txt.value.trim(), t = '';
      if (v) {
        var d = parse(v);
        if (!d) t = 'Bitte gib das Datum als TT.MM.JJJJ ein, zum Beispiel ' + de(min) + '.';
        else if (d < min) t = 'Der Wunschtermin muss frühestens morgen sein (' + de(min) + '). Für heute lass das Feld einfach leer, dann kommt dein Song so schnell wie möglich.';
        else if (d > max) t = 'Bitte wähle einen Termin innerhalb der nächsten 12 Monate.';
        else { txt.value = de(d); if (nat) nat.value = iso(d); }
      }
      txt.setCustomValidity(t);
      if (msg && (show || !t)) { msg.textContent = t; msg.hidden = !t; }
      if (t && focus) txt.focus();
      return !t;
    }
    txt.addEventListener('input', function (e) {
      if (e.inputType && e.inputType.indexOf('delete') === 0) return;
      var digits = txt.value.replace(/\D/g, '').slice(0, 8), out = digits;
      if (digits.length > 4) out = digits.slice(0, 2) + '.' + digits.slice(2, 4) + '.' + digits.slice(4);
      else if (digits.length > 2) out = digits.slice(0, 2) + '.' + digits.slice(2);
      if (/^\d+$/.test(txt.value)) txt.value = out; // nur reine Ziffern automatisch mit Punkten versehen
      if (txt.validationMessage) check(false);
    });
    txt.addEventListener('blur', function () { check(true); });
    if (nat) {
      nat.addEventListener('click', function () { try { if (nat.showPicker) nat.showPicker(); } catch (x) {} });
      nat.addEventListener('change', function () {
        if (!nat.value) return;
        var p = nat.value.split('-'); txt.value = p[2] + '.' + p[1] + '.' + p[0];
        check(true); form.dispatchEvent(new Event('change'));
      });
    }
    return { check: check };
  }

  // Fotos fürs Lyrics-Video: eine Auswahl, Versand als einzelne Eigenschaften „Foto 1“ bis „Foto 10“
  function initPhotos(form, nameInput) {
    var wrap = form.querySelector('[data-video-fields]');
    var noop = { ready: function () { return Promise.resolve(); }, toggle: function () {}, rightsOk: function () { return true; }, missingCover: function () { return false; }, focus: function () {}, append: function () { return 0; } };
    if (!wrap) return noop;
    var MAX = 10, MAX_BYTES = 20 * 1024 * 1024, MIN_PX = 1000, LONG_PX = 2500;
    var input = wrap.querySelector('[data-photo-input]'), add = wrap.querySelector('[data-photo-add]'), addText = wrap.querySelector('[data-photo-add-text]');
    var grid = wrap.querySelector('[data-photo-grid]'), count = wrap.querySelector('[data-photo-count]'), msg = wrap.querySelector('[data-photo-msg]');
    var rights = wrap.querySelector('[data-photo-rights]'), rightsBox = wrap.querySelector('[data-photo-rights-box]');
    var title = wrap.querySelector('[data-video-title]'), sub = wrap.querySelector('[data-video-sub]'), subCount = wrap.querySelector('[data-video-sub-count]');
    var photos = [], active = false, cover = false, titleAuto = '';
    var coverHint = wrap.querySelector('[data-cover-hint]'), textOnly = wrap.querySelector('[data-textonly-hint]');
    var optTag = wrap.querySelector('[data-photo-optional]'), reqTag = wrap.querySelector('[data-photo-required]');
    var okType = function (f) { return /^image\/(jpeg|png|heic|heif)$/i.test(f.type) || /\.(jpe?g|png|heic|heif)$/i.test(f.name); };
    var previewable = function (f) { return /^image\/(jpeg|png)$/i.test(f.type) || /\.(jpe?g|png)$/i.test(f.name); };
    var mb = function (b) { return (b / 1048576).toLocaleString('de-DE', { maximumFractionDigits: 1 }) + '\u00a0MB'; };

    function syncTitle() {
      if (!title || !nameInput) return;
      var n = nameInput.value.trim(), auto = n ? 'Für ' + n : '';
      if (title.value === titleAuto) title.value = auto;
      titleAuto = auto;
    }
    if (nameInput) nameInput.addEventListener('input', syncTitle);
    if (sub && subCount) sub.addEventListener('input', function () { subCount.textContent = sub.value.length; });

    function say(lines) {
      if (!msg) return;
      msg.hidden = !lines.length;
      msg.innerHTML = '';
      lines.forEach(function (t) { var p = document.createElement('p'); p.textContent = t; msg.appendChild(p); });
    }

    function warnEl(ph) {
      var w = document.createElement('span'); w.className = 'photo-warn';
      w.textContent = 'Recht klein (' + ph.w + '\u00a0×\u00a0' + ph.h + '\u00a0Pixel), kann im Video unscharf wirken.';
      return w;
    }

    // Große JPG/PNG vor dem Upload auf max. 2500 px (lange Seite) verkleinern, HEIC bleibt unverändert
    function shrink(ph) {
      var f = ph.file;
      if (!previewable(f) || !window.createImageBitmap || !HTMLCanvasElement.prototype.toBlob) return Promise.resolve();
      return createImageBitmap(f, { imageOrientation: 'from-image' }).then(function (bmp) {
        var long = Math.max(bmp.width, bmp.height);
        if (long <= LONG_PX) { bmp.close && bmp.close(); return; }
        var k = LONG_PX / long, w = Math.round(bmp.width * k), h = Math.round(bmp.height * k);
        var c = document.createElement('canvas'); c.width = w; c.height = h;
        var ctx = c.getContext('2d'); ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
        ctx.imageSmoothingQuality = 'high'; ctx.drawImage(bmp, 0, 0, w, h); bmp.close && bmp.close();
        return new Promise(function (res) { c.toBlob(res, 'image/jpeg', 0.9); }).then(function (b) {
          if (!b || b.size >= f.size) return;
          var nm = f.name.replace(/\.(jpe?g|png)$/i, '') + '.jpg';
          try { ph.upload = new File([b], nm, { type: 'image/jpeg' }); } catch (x) { b.name = nm; ph.upload = b; }
        });
      }).catch(function () {});
    }

    function coverPreview(ph) {
      var box = document.createElement('div'); box.className = 'photo-crop';
      var fr = document.createElement('span'); fr.className = 'photo-crop-frame'; fr.setAttribute('aria-hidden', 'true');
      fr.style.backgroundImage = 'url("' + ph.url + '")'; box.appendChild(fr);
      var t = document.createElement('span'); t.className = 'photo-crop-text';
      t.textContent = ph.w && ph.w > ph.h
        ? 'Foto 1 ist im Querformat. Fürs Hochformat-Cover schneiden wir es mittig zu, so wie in der Vorschau. Passt der Ausschnitt nicht, mach ein anderes Foto zum Cover.'
        : 'So ungefähr sieht der Ausschnitt auf dem Acrylglas-Cover aus.';
      box.appendChild(t);
      return box;
    }

    function render() {
      grid.innerHTML = '';
      var uid = wrap.id || (wrap.id = 'ow-video-' + Math.random().toString(36).slice(2, 8));
      photos.forEach(function (ph, i) {
        var li = document.createElement('li'); li.className = 'photo' + (ph.isNew ? ' is-new' : '');
        ph.isNew = false; ph.li = li;
        var fig = document.createElement('div'); fig.className = 'photo-thumb';
        if (ph.url) { var im = document.createElement('img'); im.src = ph.url; im.alt = 'Foto ' + (i + 1) + (cover && i === 0 ? ' (Cover)' : '') + ': ' + ph.file.name; fig.appendChild(im); }
        else { var ph2 = document.createElement('span'); ph2.className = 'photo-ph'; ph2.textContent = 'HEIC'; ph2.setAttribute('aria-hidden', 'true'); fig.appendChild(ph2); }
        var nr = document.createElement('span'); nr.className = 'photo-nr'; nr.textContent = i + 1; nr.setAttribute('aria-hidden', 'true'); fig.appendChild(nr);
        if (cover && i === 0) { var ct = document.createElement('span'); ct.className = 'photo-cover'; ct.textContent = 'Cover'; fig.appendChild(ct); }
        li.appendChild(fig);
        var head = document.createElement('div'); head.className = 'photo-head';
        var cap = document.createElement('span'); cap.className = 'photo-name'; cap.textContent = ph.file.name; head.appendChild(cap);
        var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'photo-rm'; rm.setAttribute('aria-label', 'Foto ' + (i + 1) + ' entfernen');
        rm.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg>';
        rm.addEventListener('click', function () {
          if (ph.url) URL.revokeObjectURL(ph.url);
          photos.splice(i, 1); render(); say([]);
          if (!input.disabled) input.focus();
        });
        head.appendChild(rm); li.appendChild(head);
        var body = document.createElement('div'); body.className = 'photo-body';
        var id = uid + '-kw-' + i;
        var lab = document.createElement('label'); lab.className = 'photo-kw-label'; lab.htmlFor = id;
        lab.innerHTML = 'Stichwort zum Foto <span class="field-optional">(optional)</span>';
        var kw = document.createElement('input'); kw.type = 'text'; kw.id = id; kw.maxLength = 40; kw.autocomplete = 'off';
        kw.placeholder = 'z. B. Lissabon, Hochzeit, Kindheit'; kw.value = ph.note || '';
        kw.addEventListener('input', function () { ph.note = kw.value; });
        body.appendChild(lab); body.appendChild(kw);
        if (ph.small) body.appendChild(warnEl(ph));
        if (cover && i === 0 && ph.url) body.appendChild(coverPreview(ph));
        if (cover && i > 0) {
          var mk = document.createElement('button'); mk.type = 'button'; mk.className = 'photo-mkcover';
          mk.textContent = 'Als Cover verwenden'; mk.setAttribute('aria-label', 'Foto ' + (i + 1) + ' als Cover verwenden');
          mk.addEventListener('click', function () {
            photos.splice(i, 1); photos.unshift(ph); render();
            var first = grid.querySelector('.photo-rm'); if (first) first.focus();
          });
          body.appendChild(mk);
        }
        li.appendChild(body);
        grid.appendChild(li);
      });
      var n = photos.length;
      count.textContent = n ? n + ' von ' + MAX + ' Fotos ausgewählt' : '';
      addText.textContent = n ? 'Weitere Fotos hinzufügen' : 'Fotos auswählen';
      var full = n >= MAX;
      add.hidden = full; input.disabled = full || !active;
      var need = active && n > 0;
      rights.hidden = !need; rightsBox.disabled = !need; rightsBox.required = need;
      if (!need) rightsBox.checked = false;
      form.dispatchEvent(new Event('change'));
    }

    function measure(ph) {
      if (!ph.url) return;
      var im = new Image();
      im.onload = function () {
        ph.w = im.naturalWidth; ph.h = im.naturalHeight; ph.small = Math.max(ph.w, ph.h) < MIN_PX;
        if (ph.small && ph.li && !ph.li.querySelector('.photo-warn')) ph.li.querySelector('.photo-body').appendChild(warnEl(ph));
        if (cover && photos[0] === ph) render();
      };
      im.src = ph.url;
    }

    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []), notes = [];
      files.forEach(function (f) {
        if (!okType(f)) { notes.push('„' + f.name + '“ ist kein JPG, PNG oder HEIC und wurde nicht übernommen.'); return; }
        if (f.size > MAX_BYTES) { notes.push('„' + f.name + '“ ist mit ' + mb(f.size) + ' größer als 20\u00a0MB und wurde nicht übernommen.'); return; }
        if (photos.length >= MAX) { notes.push('Es passen höchstens 10 Fotos ins Video. „' + f.name + '“ haben wir weggelassen.'); return; }
        var ph = { file: f, url: previewable(f) && window.URL ? URL.createObjectURL(f) : '', isNew: true };
        photos.push(ph); measure(ph); ph.ready = shrink(ph);
      });
      input.value = '';
      say(notes); render();
    });

    return {
      toggle: function (on, isCover) {
        isCover = !!(on && isCover);
        if (on === active && isCover === cover) return;
        active = on; cover = isCover; wrap.hidden = !on;
        if (coverHint) coverHint.hidden = !cover;
        if (textOnly) textOnly.hidden = cover;
        if (optTag) optTag.hidden = cover;
        if (reqTag) reqTag.hidden = !cover;
        [title, sub].forEach(function (el) { if (el) el.disabled = !on; });
        if (on) syncTitle();
        render();
      },
      rightsOk: function () { return !active || (cover ? photos.length > 0 && rightsBox.checked : (!photos.length || rightsBox.checked)); },
      ready: function () { return Promise.all(photos.map(function (ph) { return ph.ready || Promise.resolve(); })); },
      missingCover: function () { return active && cover && !photos.length; },
      focus: function () { say(['Bitte wähle mindestens ein Foto aus. Foto 1 kommt aufs Cover.']); wrap.scrollIntoView({ block: 'start', behavior: 'auto' }); if (!input.disabled) input.focus({ preventScroll: true }); },
      append: function (fd) {
        if (!active) return 0;
        if (cover && photos.length) fd.append('properties[Cover]', 'Foto 1');
        photos.forEach(function (ph, i) {
          var up = ph.upload || ph.file;
          fd.append('properties[Foto ' + (i + 1) + ']', up, up.name || ph.file.name);
          var note = (ph.note || '').trim();
          if (note) fd.append('properties[Foto ' + (i + 1) + ' Stichwort]', note);
        });
        return photos.length;
      }
    };
  }
})();

// Hero-Video: startet nur ohne reduzierte Bewegung und ohne Datensparmodus; Bild bleibt LCP und Fallback
(function () {
  var v = document.querySelector('[data-hero-video]');
  if (!v) return;
  var c = navigator.connection || {};
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) { v.remove(); return; }
  var start = function () {
    v.muted = true; v.autoplay = true; v.preload = 'auto';
    v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
    var p = v.play(); if (p && p.catch) p.catch(function () { v.remove(); });
  };
  if (document.readyState === 'complete') setTimeout(start, 200); else window.addEventListener('load', function () { setTimeout(start, 200); }, { once: true });
  document.addEventListener('visibilitychange', function () { if (document.hidden) v.pause(); else if (v.classList.contains('is-playing')) v.play(); });
})();

// Film mit Ton im Dialog (nur wenn im Hero eine Film-URL gesetzt ist)
document.querySelectorAll('[data-film-open]').forEach(function (btn) {
  var d = document.getElementById(btn.getAttribute('aria-controls'));
  if (!d || typeof d.showModal !== 'function') { btn.hidden = true; return; }
  var v = d.querySelector('[data-film-video]'), root = document.documentElement;
  var close = function () { if (v) v.pause(); if (d.open) d.close(); };
  btn.addEventListener('click', function () { root.classList.add('drawer-lock'); d.showModal(); if (v) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
  d.addEventListener('close', function () { if (v) v.pause(); root.classList.remove('drawer-lock'); btn.focus({ preventScroll: true }); });
  d.querySelector('[data-film-close]').addEventListener('click', close);
  d.addEventListener('click', function (e) { if (e.target === d) close(); });
});

// Sticky-Button auf der Produktseite (Handy): erscheint, wenn der echte Button nicht sichtbar ist
(function () {
  var bar = document.querySelector('[data-sticky-atc]'), atc = document.querySelector('[data-atc]');
  if (!bar || !atc || !('IntersectionObserver' in window)) return;
  var form = atc.closest('form'), total = document.querySelector('[data-total]'), st = bar.querySelector('[data-sticky-total]');
  bar.hidden = false;
  var formTop = form ? form.getBoundingClientRect().top + window.scrollY : 0;
  var io = new IntersectionObserver(function (es) {
    var vis = es[0].isIntersecting, past = window.scrollY + window.innerHeight > formTop + 200;
    bar.classList.toggle('is-on', !vis && past);
    if (total && st) st.textContent = total.textContent;
  }, { threshold: 0 });
  io.observe(atc);
  window.addEventListener('scroll', function () { if (total && st) st.textContent = total.textContent; }, { passive: true });
  bar.querySelector('[data-sticky-go]').addEventListener('click', function () {
    var first = form && form.querySelector(':invalid');
    var target = first || atc;
    target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 350);
  });
})();

/* CRO13: Header-Schatten beim Scrollen */
(function () {
  var h = document.querySelector('[data-header]'); if (!h) return;
  var on = false, tick = false;
  function u() { tick = false; var s = window.scrollY > 4; if (s !== on) { on = s; h.classList.toggle('is-scrolled', s); } }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(u); } }, { passive: true });
  u();
})();
